var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import { Modal } from 'react-bootstrap';
import CloseIcon from '@mui/icons-material/Close';
function ModalDownloadTemplate(_a) {
    var show = _a.show, closeModal = _a.closeModal;
    return (_jsxs(Modal, __assign({ "aria-labelledby": "contained-modal-title-vcenter", centered: true, className: "default-modal-styling" }, { show: show, onHide: closeModal }, { children: [_jsxs(Modal.Header, __assign({ style: { paddingLeft: "0.9rem" } }, { children: [_jsx(Modal.Title, { children: "Aviso" }), _jsx(CloseIcon, { className: "modal-confirm-email-close-icon", onClick: closeModal })] })), _jsx(Modal.Body, { children: "Preencha o modelo com o CPF dos assinantes que deseja atualizar, e depois fa\u00E7a o upload na plataforma." }), _jsx(Modal.Footer, { children: _jsx(Link, __assign({ to: "/examples/update-subscribers.csv", target: "_blank", download: true, className: "blue-button", style: { padding: "0.4rem" }, onClick: closeModal }, { children: "Baixar Modelo" })) })] })));
}
export default ModalDownloadTemplate;
